<template>
	<div>
		<div class="user_info">
			<div class="user_avfo">
				<img src="../../assets/1.jpg" />
				<p>{{userInfo.loginName}}</p>
			</div>
			<a @click="loginout" class="exit">退出</a>
		</div>
		<section class="user_list">
			<ul>
				<li :class="current==1?'active':''" @click="change(1)"><span>我的预约 {{reserveLiveLength}}</span></li>
				<li :class="current==2?'active':''" @click="change(2)"><span>我的收藏 {{liveLength}}</span></li>
			</ul>
			<div class="user_box">
				<div v-if="current == 1">
					<div class="ub_item" v-for="(item,index) in reserveLiveList" :key="index" @click="toVideo(item)">
						<a>
							<img :src="item.imageUrl" class="ub_pic" />
						</a>
						<div class="ub_info">
							<h2>{{item.title}}</h2>
							<p>北京度量单位有限公司</p>
							<div>{{item.livetime}}<a @click.stop="reserveLive(item)" class="cancel">取消</a></div>
						</div>
					</div>
				</div>
				<div v-if="current == 2">
					<div class="ub_item" v-for="(item,index) in liveList" :key="index" @click="toVideo(item)">
						<a>
							<img :src="item.imageUrl" class="ub_pic" />
						</a>
						<div class="ub_info">
							<h2>{{item.title}}</h2>
							<p>北京度量单位有限公司</p>
							<div>{{item.livetime}}<a @click.stop="collectLive(item)" class="collect"></a></div>
						</div>
					</div>
				</div>
			</div>
		</section>
		<div class="empty" v-if="reserveLiveList.length == 0 && current == 1">
			<van-empty image-size="120" description="暂无预约" />
		</div>
		<div class="empty" v-if="liveList.length == 0 && current == 2">
			<van-empty image-size="120" description="暂无收藏" />
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import {
		Toast
	} from 'vant';
	import {
		queryMyBook,
		queryMyCollect,
		collectRoom,
		bookRoom
	} from '@/request/api.js'
	import {
		checkAuthonToken,
		logoOut
	} from '@/request/http.js'
	import {
		onLogin,
		getUrlSearch
	} from '@/utils/thread.js'
	export default {
		data() {
			return {
				current: 1,
				userInfo: {},
				reserveLiveList: [],
				liveList: [],
				reserveLiveLength: 0,
				liveLength: 0,
			}
		},
		activated() {
			let that = this
			checkAuthonToken()
				.then(res => {
					this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
					this.queryMyBook(this.userInfo.token)
					this.queryMyCollect(this.userInfo.token)
				}).catch(e => {
					onLogin()
				})
		},
		methods: {
			//观看直播
			toVideo(item) {
				window.location.href = 'https://live.cacpaper.com/#/live/home?roomId=' + item.id
			},
			collectionLiveApi(item) {
				collectRoom({
					collectTag: 0,
					roomId: item.id,
					token: this.userInfo.token
				}).then(res => {
					if (res.status == 200) {
						this.queryMyCollect(this.userInfo.token)
					} else {
						Toast('操作失败,请稍后重试');
					}
				}).catch(e => {
					Toast('网络错误');
				})
			},
			//取消收藏
			collectLive(item) {
				checkAuthonToken()
					.then(res => {
						this.collectionLiveApi(item)
					}).catch(e => {
						if (!e) {
							onLogin()
						}
					})
			},
			reserveLiveApi(item) {
				bookRoom({
					bookTag: 0,
					roomId: item.id,
					token: this.userInfo.token
				}).then(res => {
					if (res.status == 200) {
						this.queryMyBook(this.userInfo.token)
					} else {
						Toast('预约失败,请稍后重试');
					}
				}).catch(e => {
					Toast('网络错误');
				})
			},
			//取消预约直播
			reserveLive(item) {
				checkAuthonToken()
					.then(res => {
						this.reserveLiveApi(item)
					}).catch(e => {
						onLogin()
					})
			},
			change(index) {
				this.current = index;
				if (index == 2) {
					this.liveList = []
					this.queryMyCollect(this.userInfo.token)
				}
				if (index == 1) {
					this.reserveLiveList = []
					this.queryMyBook(this.userInfo.token)
				}
			},
			//我的预约
			queryMyBook(token) {
				queryMyBook(token).then(res => {
					if (res.status == 200) {
						this.reserveLiveLength = res.data.data.length
						this.reserveLiveList = res.data.data
					} else {
						Toast('我的预约获取失败')
					}
				}).catch(e => {
					Toast('网络错误')
				})
			},
			//我的收藏
			queryMyCollect(token) {
				queryMyCollect(token).then(res => {
					if (res.status == 200) {
						this.liveLength = res.data.data.length
						this.liveList = res.data.data
					} else {
						Toast('我的预约获取失败')
					}
				}).catch(e => {
					Toast('网络错误')
				})
			},
			//退出登录
			loginout() {
				logoOut()
					.then(res => {
						this.$router.push({
							path: '/'
						})
					}).catch(e => {
						Toast('退出失败')
					})
			},
		}
	}
</script>

<style>
	@import '../../utils/main.css';

	.empty {
		display: flex;
		justify-content: center;
		text-align: center;
	}
</style>
